// PropertyCard.js
import React from "react";
import "./PropertyCard.css";
import Badge from "./Badge";
import { LocationOn } from "@mui/icons-material";

function PropertyCard(props) {
  return (
    <div className="PropertyCard">
      <a href={props.slug}>
        <div className="PropertyCard__image-container">
          <img src={props.img} alt={props.name} />
          <Badge label={props.status} badgecolor={props.badgecolor} />
        </div>
        <div className="PropertyCard__txtcontent">
          <div className="PropertyCard__name">
            <p>{props.name}</p>
          </div>
          <div className="PropertyCard__location">
            <div className="PropertyCard__location__icon">
              <LocationOn />
            </div>

            <p>{props.location}</p>
          </div>
          <div className="PropertyCard__price">
            <p>{props.price}</p>
          </div>

          <div className="PropertyCard__about">
            <p>
              {props.bedrooms} Bedrooms • {props.bathrooms} Bathrooms •{" "}
              {props.housesize}
            </p>
          </div>
          <div className="PropertyCard__about__marketby">
            <p>Marketed by Luxury Spain Properties</p>
          </div>
        </div>
      </a>
    </div>
  );
}

export default PropertyCard;
